<script setup lang="ts">
import { TypographyWithPrefix } from '@rfc/rfc-components-library'
import type { DeviceModel } from '@rfc/rfc-components-library/types'

type Props = {
    data?: Partial<DeviceModel>
}
defineProps<Props>()
type Emits = {
    (e: 'refresh'): void
}
defineEmits<Emits>()
</script>

<template>
    <TypographyWithPrefix
        :prefix="$t('organization.model.organizationName')"
        :label="data?.organization_name"
        boldLabel />
</template>
